export const dateFormat = 'dddd D MMM YYYY';
export const dateTimeFormat = 'dddd D MMM YYYY h:mm A';

/**
 * Timezone options for date/time selection
 */
export const timezoneOptions = [
  { id: 'UTC', name: 'UTC (Coordinated Universal Time)' },
  { id: 'America/New_York', name: 'Eastern Time (ET)' },
  { id: 'America/Chicago', name: 'Central Time (CT)' },
  { id: 'America/Denver', name: 'Mountain Time (MT)' },
  { id: 'America/Los_Angeles', name: 'Pacific Time (PT)' },
  { id: 'Europe/London', name: 'London (GMT/BST)' },
  { id: 'Asia/Singapore', name: 'Singapore Time (SGT)' },
  { id: 'Australia/Sydney', name: 'Australian Eastern Time (AET)' },
  { id: 'Asia/Tokyo', name: 'Japan Standard Time (JST)' },
  { id: 'Asia/Shanghai', name: 'China Standard Time (CST)' },
  { id: 'Asia/Kolkata', name: 'India Standard Time (IST)' },
  { id: 'Europe/Berlin', name: 'Central European Time (CET)' },
  { id: 'Europe/Moscow', name: 'Moscow Standard Time (MSK)' },
  { id: 'America/Sao_Paulo', name: 'Brasilia Time (BRT)' },
  { id: 'Africa/Johannesburg', name: 'South Africa Standard Time (SAST)' },
  { id: 'Pacific/Auckland', name: 'New Zealand Standard Time (NZST)' },
];

/**
 * Account region options based on Snowflake documentation
 * https://docs.snowflake.com/en/user-guide/admin-account-identifier#region-ids
 */
export const regionOptions = [
  // AWS regions
  { id: 'aws_us_west_2', name: 'US West (Oregon) (aws_us_west_2)' },
  { id: 'aws_us_east_1', name: 'US East (N. Virginia) (aws_us_east_1)' },
  { id: 'aws_us_east_2', name: 'US East (Ohio) (aws_us_east_2)' },
  { id: 'aws_ca_central_1', name: 'Canada (Central) (aws_ca_central_1)' },
  { id: 'aws_sa_east_1', name: 'South America (São Paulo) (aws_sa_east_1)' },
  { id: 'aws_eu_west_1', name: 'EU (Ireland) (aws_eu_west_1)' },
  { id: 'aws_eu_west_2', name: 'EU (London) (aws_eu_west_2)' },
  { id: 'aws_eu_west_3', name: 'EU (Paris) (aws_eu_west_3)' },
  { id: 'aws_eu_central_1', name: 'EU (Frankfurt) (aws_eu_central_1)' },
  { id: 'aws_eu_central_2', name: 'EU (Zurich) (aws_eu_central_2)' },
  { id: 'aws_eu_north_1', name: 'EU (Stockholm) (aws_eu_north_1)' },
  { id: 'aws_ap_northeast_1', name: 'Asia Pacific (Tokyo) (aws_ap_northeast_1)' },
  { id: 'aws_ap_northeast_3', name: 'Asia Pacific (Osaka) (aws_ap_northeast_3)' },
  { id: 'aws_ap_northeast_2', name: 'Asia Pacific (Seoul) (aws_ap_northeast_2)' },
  { id: 'aws_ap_south_1', name: 'Asia Pacific (Mumbai) (aws_ap_south_1)' },
  { id: 'aws_ap_southeast_1', name: 'Asia Pacific (Singapore) (aws_ap_southeast_1)' },
  { id: 'aws_ap_southeast_2', name: 'Asia Pacific (Sydney) (aws_ap_southeast_2)' },
  { id: 'aws_ap_southeast_3', name: 'Asia Pacific (Jakarta) (aws_ap_southeast_3)' },
  { id: 'gcp_us_central1', name: 'US Central1 (Iowa) (gcp_us_central1)' },
  { id: 'gcp_us_east4', name: 'US East4 (N. Virginia) (gcp_us_east4)' },
  { id: 'gcp_europe_west2', name: 'Europe West2 (London) (gcp_europe_west2)' },
  { id: 'gcp_europe_west3', name: 'Europe West3 (Frankfurt) (gcp_europe_west3)' },
  { id: 'gcp_europe_west4', name: 'Europe West4 (Netherlands) (gcp_europe_west4)' },
  { id: 'gcp_me_central2', name: 'Middle East Central2 (Dammam) (gcp_me_central2)' },
  { id: 'azure_westus2', name: 'West US 2 (Washington) (azure_westus2)' },
  { id: 'azure_centralus', name: 'Central US (Iowa) (azure_centralus)' },
  { id: 'azure_southcentralus', name: 'South Central US (Texas) (azure_southcentralus)' },
  { id: 'azure_eastus2', name: 'East US 2 (Virginia) (azure_eastus2)' },
  { id: 'azure_canadacentral', name: 'Canada Central (Toronto) (azure_canadacentral)' },
  { id: 'azure_mexicocentral', name: 'Mexico Central (Mexico City) (azure_mexicocentral)' },
  { id: 'azure_uksouth', name: 'UK South (London) (azure_uksouth)' },
  { id: 'azure_northeurope', name: 'North Europe (Ireland) (azure_northeurope)' },
  { id: 'azure_westeurope', name: 'West Europe (Netherlands) (azure_westeurope)' },
  { id: 'azure_switzerlandnorth', name: 'Switzerland North (Zurich) (azure_switzerlandnorth)' },
  { id: 'azure_uaenorth', name: 'UAE North (Dubai) (azure_uaenorth)' },
  { id: 'azure_centralindia', name: 'Central India (Pune) (azure_centralindia)' },
  { id: 'azure_japaneast', name: 'Japan East (Tokyo) (azure_japaneast)' },
  { id: 'azure_southeastasia', name: 'Southeast Asia (Singapore) (azure_southeastasia)' },
  { id: 'azure_australiaeast', name: 'Australia East (New South Wales) (azure_australiaeast)' },
];

export const repoSizeWarning =
  'This is a large solution. Large solutions can lead to performance issues and longer processing times. Exceeding 50MB is considered a large solution.';
